<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="situationReportingFilter === 'sit_rep'"
            variant="outline-secondary"
            @click="updateSituationReportingFilter('sit_rep')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="situationReportingFilter === 'sit'"
            variant="outline-primary"
            @click="updateSituationReportingFilter('sit')"
        >
            Situations
        </b-button>
        <b-button
            :pressed="situationReportingFilter === 'rep'"
            variant="outline-primary"
            @click="updateSituationReportingFilter('rep')"
        >
            Reporting
        </b-button>
    </b-button-group>
</template>

<script>
import {mapState} from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'SituationReportingFilter',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            situationReportingFilter: (state) => state.browsing.situationReportingFilter,
        }),
    },

    methods: {
        updateSituationReportingFilter(value) {
            this.$store.commit('browsing/SET_SITUATION_REPORTING_TAX_FILTER', value)
            this.$root.$refs.sitTable.getItems()
        },
    },
}
</script>

<style scoped></style>
